import React, { useState, useEffect } from 'react';
import { Form, Col, Button, Row, Table } from 'react-bootstrap';
import axios from '../Axiosinstance';
// import './feedback.css';
import { useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Head from '../StudentLogin/Headstu';
import { logoImage, buttonBackgroundColor } from '../common';
import { AiFillStar } from 'react-icons/ai';

const Rating = () => {
    const [ratings, setRatings] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [feedbackId, setFeedbackId] = useState("");
    const [feedbackDetails, setFeedbackDetails] = useState([]);
    const [unsubmittedFeedback, setUnsubmittedFeedback] = useState([]);
    const [selectedModule, setSelectedModule] = useState(null);

    const { batchid } = useParams();
    const navigate = useNavigate();

    const studentteacherid = localStorage.getItem('studentteacherid');
    const studentname = localStorage.getItem('name');

    useEffect(() => {
        const fetchFeedbackDetails = async () => {
            try {
                const feedbackModulesResponse = await axios.get(`generalfeedbackcreate/batch/${batchid}`);
                const feedbackModules = feedbackModulesResponse.data;

                const submittedFeedbackResponse = await axios.get(`generalfeedback/student/${studentteacherid}`);
                const submittedFeedback = submittedFeedbackResponse.data;

                const unsubmitted = feedbackModules.filter(
                    module => !submittedFeedback.some(feedback => feedback.feedbackId === module.id)
                );

                setFeedbackDetails(feedbackModules);
                setUnsubmittedFeedback(unsubmitted);
            } catch (error) {
                console.error('Error fetching feedback data:', error);
            }
        };

        fetchFeedbackDetails();
    }, [batchid, studentteacherid]);

    useEffect(() => {
        if (selectedModule) {
            setQuestions(selectedModule.questions);
            setFeedbackId(selectedModule.id);
        }
    }, [selectedModule]);

    const handleRatingChange = (rating, index) => {
        const updatedRatings = [...ratings];
        updatedRatings[index] = rating;
        setRatings(updatedRatings);
    };

    const handleCancel = () => {
        window.alert('Feedback submission cancelled.');
        navigate('/Dashboard');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (ratings.length !== questions.length) {
            toast.error('Please answer all questions before submitting.');
            return;
        }

        const feedbackData = {
            feedbackId: feedbackId,
            studentId: studentteacherid,
            studentName: studentname,
            batchId: batchid,
            questions: questions,
            answers: ratings.map((rating) => {
                switch (rating) {
                    case 1:
                        return "Poor(20%)";
                    case 2:
                        return "Fair(40%)";
                    case 3:
                        return "Satisfactory(60%)";
                    case 4:
                        return "Very Good(80%)";
                    case 5:
                        return "Excellent(90%)";
                    default:
                        return "";
                }
            })
        };

        try {
            const response = await axios.post('generalfeedback/', feedbackData);
            console.log('Feedback submitted:', response.data);
            toast.success('Feedback submitted successfully!');
        } catch (error) {
            console.error('Error submitting feedback:', error);
            toast.error('Failed to submit feedback. Please try again later.');
        }
        navigate('/Dashboard');
    };

    const nav = () => {
        navigate('/Dashboard');
    }

    return (
        <>
            <Head showNotifications={true} />
            <div style={{ maxWidth: '1000px', margin: 'auto', padding: '20px' }}>
                <ToastContainer position="bottom-right" autoClose={5000} />

                {/* <div >
                        <img
                            src={logoImage}
                            alt="logoImage"
                            style={{ width: '300px', height: '60px' }}
                        />
                    </div> */}
                {/* <h1 style={{ flex: '1', textAlign: 'center', margin: 0 , color: 'black'  }}>
                        JURONG ACADEMY
                    </h1> */}


                <br />
                <div style={{ overflowY: 'auto' }}>
                    {unsubmittedFeedback.length === 0 ? (
                      <div className="d-flex flex-column align-items-center justify-content-center p-5">
                      <div className="bg-light p-4 rounded-4 shadow-sm text-center" style={{ maxWidth: '400px', width: '100%' }}>
                        <h4 className="mb-3 text-danger fw-bold">No Feedbacks Found</h4>
                        <p className="text-secondary mb-4" style={{ fontSize: '15px' }}>
                          It looks like there are no feedbacks available at the moment. Please check back later!
                        </p>
                        <Button variant="contained" onClick={nav} style={{   backgroundColor: buttonBackgroundColor,
                                    color: "white",
                                    minWidth: "120px", }}>
                                Back
                            </Button>
                      </div>
                    </div>
                    
                    ) : (
                        <Form onSubmit={handleSubmit} >
                            <Row>
                                <div className="text-center mb-4">
                                    <h2 className="fw-bold text-primary" style={{ letterSpacing: '1px' }}>
                                        Module Feedback Survey
                                    </h2>
                                    <hr className="w-25 mx-auto" />
                                </div>
                                <Col xs={12} className="mb-4">
                                    <Form.Group controlId="moduleSelect" className="mb-4">
                                        <Form.Label className="fw-semibold text-dark">Select Module</Form.Label>
                                        <Form.Select
                                            aria-label="Select a module"
                                            className="shadow-sm"
                                            onChange={(e) =>
                                                setSelectedModule(unsubmittedFeedback.find(module => module.id === parseInt(e.target.value)))
                                            }
                                        >
                                            <option value="">-- Select a module --</option>
                                            {unsubmittedFeedback.map((module) => (
                                                <option key={module.id} value={module.id}>
                                                    {module.moduleName} - {module.dateTaken}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <p style={{ textAlign: 'left', color: 'black' }}>Dear Students,</p>
                                <div style={{ textAlign: 'justify' }}>
                                    <p>
                                        Module feedback survey is taken at the end of every module on the module content, duration, course material,
                                        module assessment, evaluation of lectures & teaching methods, facilities and overall satisfaction.
                                        Please answer the following questions about your experiences in this module and the lecturing of this class.
                                        For each question mark the box which best reflects those experiences. Your responses will be completely anonymous,
                                        confidential, and used to improve the quality of the courses and modules.
                                    </p>
                                </div>
                                
                                </Col>

                               
                            </Row>
                            {selectedModule && (
  <div className="p-3">
    <Row>
      {/* Instruction Box */}
      <Col xs={12} className="mb-4">
        <div className="bg-light p-3 rounded shadow-sm border-start border-4 border-primary">
          <p className="mb-1 fs-6 fw-semibold text-dark">
            Please select your degree of satisfaction:
          </p>
          <p className="mb-0 text-secondary" style={{ fontSize: '14px' }}>
            <strong>1</strong>: Poor (20%) &nbsp;|&nbsp;
            <strong>2</strong>: Fair (40%) &nbsp;|&nbsp;
            <strong>3</strong>: Satisfactory (60%) &nbsp;|&nbsp;
            <strong>4</strong>: Very Good (80%) &nbsp;|&nbsp;
            <strong>5</strong>: Excellent (90%)
          </p>
        </div>
      </Col>

      {/* Questions List */}
      {questions.map((question, index) => (
        <Col key={index} xs={12} className="mb-3">
          {/* Section Headers */}
          {(index === 0 || index === 5 || index === 11) && (
            <div className="mb-2">
              <h6 className="text-white bg-primary px-3 py-2 rounded shadow-sm mb-0">
                {index === 0 && '📘 Section A: Course Content'}
                {index === 5 && '🧑‍🏫 Section B: Instructor Evaluation'}
                {index === 11 && '🌟 Section C: Overall Experience'}
              </h6>
            </div>
          )}

          {/* Question Card */}
          <div className="bg-white border rounded-4 shadow-sm px-3 py-3">
            <Row className="align-items-center">
              {/* Question Text */}
              <Col xs={12} md={6} className="mb-2 mb-md-0">
                <span className="fw-semibold text-dark">
                  {index + 1}. {question}
                </span>
              </Col>

              {/* Rating Radios */}
              <Col xs={12} md={6}>
                <div className="d-flex justify-content-between flex-nowrap">
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <div
                      key={`${index}_${rating}`}
                      className="text-center"
                      style={{
                        width: '50px',   // 🚀 Fixed width for equal spacing
                        flexShrink: 0
                      }}
                    >
                      <Form.Check
                        type="radio"
                        name={`rating_${index}`}
                        id={`rating_${index}_${rating}`}
                        checked={ratings[index] === rating}
                        onChange={() => handleRatingChange(rating, index)}
                        style={{ transform: 'scale(1.3)' }}
                      />
                      <div style={{ fontSize: '13px' }}>{rating}</div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      ))}
    </Row>
  </div>
)}




                            <div style={{ textAlign: 'center' }}>
                                <Button variant="primary" type="submit" style={{
                                    backgroundColor: buttonBackgroundColor,
                                    color: "white",
                                    minWidth: "120px", // Ensure the button has a minimum width
                                    marginRight: '10px'
                                    // Prevent button from shrinking
                                }}>
                                    Submit
                                </Button>
                                <Button variant="danger" onClick={handleCancel} style={{
                                    backgroundColor: buttonBackgroundColor,
                                    color: "white",
                                    minWidth: "120px", // Ensure the button has a minimum width

                                    // Prevent button from shrinking
                                }}>
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    )}
                </div>
            </div>
        </>
    );
};


export default Rating;
